import { render, staticRenderFns } from "./StatisticOblige.vue?vue&type=template&id=097ca8a0&scoped=true&"
import script from "./StatisticOblige.vue?vue&type=script&lang=js&"
export * from "./StatisticOblige.vue?vue&type=script&lang=js&"
import style0 from "./StatisticOblige.vue?vue&type=style&index=0&id=097ca8a0&scoped=true&lang=scss&"
import style1 from "./StatisticOblige.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ca8a0",
  null
  
)

export default component.exports